/*
 * Minimaler AdminLTE-JS-Ersatz: PushMenu + ControlSidebar.
 * Der Markup bleibt identisch (data-widget="pushmenu"/"treeview"/"control-sidebar"),
 * das Verhalten wird hier implementiert statt über admin-lte dist/js/adminlte.
 * Treeview läuft komplett über React-State (menu-open) - kein JS nötig.
 */
const SIDEBAR_SLIDE_OPEN = "control-sidebar-slide-open"

let initialized = false

export function initAdminLiteShim() {
    if (initialized) return
    initialized = true

    document.body.classList.remove("hold-transition")
    requestAnimationFrame(() => {
        document.body.classList.remove("hold-transition")
    })

    // Pushmenu: Burger-Button toggelt Sidebar
    document.addEventListener("click", (event) => {
        const pushmenu = event.target.closest('[data-widget="pushmenu"]')
        if (pushmenu) {
            const isMobile = window.matchMedia("(max-width: 991.98px)").matches
            if (isMobile) {
                document.body.classList.toggle("sidebar-open")
                document.body.classList.remove("sidebar-collapse")
            } else {
                document.body.classList.toggle("sidebar-collapse")
                document.body.classList.remove("sidebar-open")
            }
            return
        }

        // Control-Sidebar: Preiszelle öffnet den Right-Tab (nicht togglen —
        // erneuter Zellklick soll bei offenem Tab den Inhalt wechseln)
        const controlSidebarTrigger = event.target.closest('[data-widget="control-sidebar"]')
        if (controlSidebarTrigger) {
            document.body.classList.add(SIDEBAR_SLIDE_OPEN)
            return
        }

        // Close-Button der Control-Sidebar
        if (event.target.closest("button#sidebarclose")) {
            if (document.body.classList.contains(SIDEBAR_SLIDE_OPEN)) {
                event.stopPropagation()
                document.body.classList.remove(SIDEBAR_SLIDE_OPEN)
            }
            return
        }

        // Klick auf Content/Sidebar schließt Control-Sidebar (wie AdminLTE),
        // aber nicht bei erneutem Klick auf eine Preiszelle
        const outside = event.target.closest(".content-wrapper, .main-sidebar")
        if (
            outside &&
            !event.target.closest('[data-widget="control-sidebar"]') &&
            document.body.classList.contains(SIDEBAR_SLIDE_OPEN)
        ) {
            event.stopPropagation()
            document.body.classList.remove(SIDEBAR_SLIDE_OPEN)
        }
    })
}

// Kompatibilitäts-APIs für Restbestände (jquery("#rightsidebar").ControlSidebar("toggle"))
export function toggleControlSidebar() {
    document.body.classList.toggle(SIDEBAR_SLIDE_OPEN)
}

export default initAdminLiteShim